// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__eQXsD","link":"HeaderSimple_link__0uWQs"};